



















































import Vue from 'vue'
import PhrasesDetailsReportStore from '@/store/searchV3Report/phrasesDetails'
import store from '@/store'

interface ColumnDescription {
  displayName: string,
  name: string,
  class: string,
  unit: string,
}

export default Vue.extend({
  data() {
    return {
      columns: [
        {
          displayName: this.$t('search.searchPhrasesWithNoResults.phrase'),
          name: 'phrase',
          class: 'text-left',
        },
        {
          displayName: this.$t('search.searchPhrasesWithNoResults.searchCount'),
          name: 'views',
          class: 'text-right',
        },
      ] as ColumnDescription[],
      sort: 'desc',
      page: 1,
      orderBy: 'views',
    }
  },
  computed: {
    dataLoading() {
      return PhrasesDetailsReportStore.state.emptyResults.dataLoading
    },
    results() {
      return PhrasesDetailsReportStore.state.emptyResults.data
    },
    totalPages() {
      return PhrasesDetailsReportStore.state.emptyResults.totalPages
    },
    start() {
      return (store.state as any).search.dateRange.start
    },
    end() {
      return (store.state as any).search.dateRange.end
    },
    dataLoadingFile() {
      return PhrasesDetailsReportStore.state.emptyResults.fileDataLoading
    },
  },
  watch: {
    start() {
      PhrasesDetailsReportStore.commit('setEmptyResultTimeFrame', {start: this.start, end: this.end})
      this.getData()
    },
    end() {
      PhrasesDetailsReportStore.commit('setEmptyResultTimeFrame', {start: this.start, end: this.end})
      this.getData()
    },
    page() {
      PhrasesDetailsReportStore.commit('setEmptyResultPage', this.page)
      this.getData()
    },
  },
  mounted() {
    PhrasesDetailsReportStore.commit('setEmptyResultTimeFrame', {start: this.start, end: this.end})
    this.getData()
  },
  methods: {
    isOrderByThisColumnActive(columnName: string): boolean {
      return this.orderBy === columnName
    },
    getArrowUpOrDown(): string {
      return this.sort === 'asc' ? 'expand_less' : 'expand_more'
    },
    flipSortDirection() {
      if (this.sort === 'asc') {
        this.sort = 'desc'
      } else {
        this.sort = 'asc'
      }
    },
    setDefaultSortDirectionForColumn(column: ColumnDescription) {
      this.orderBy = column.name
      this.sort = 'desc'
    },
    manageOrder(column: ColumnDescription) {
      if (this.orderBy === column.name) {
        this.flipSortDirection()
      } else {
        this.setDefaultSortDirectionForColumn(column)
      }
      PhrasesDetailsReportStore.commit('setEmptyResultOrderBy', column.name)
      PhrasesDetailsReportStore.commit('setEmptyResultSort', this.sort)
      this.getData()
    },
    getData() {
      PhrasesDetailsReportStore.dispatch('getEmptyResultsPhrasesData')
    },
    getFileWithData() {
      PhrasesDetailsReportStore.dispatch('getEmptyResultsPhrasesDataFile')
    },
  },

})
